import { useRouter } from 'next/navigation'
import { FC, useCallback } from 'react'

import { NotificationApiType } from '@/api/models/notifications/lib/notifications.types'
import { cn } from '@/app/utils'

import NotificationCardBody from './NotificationCardBody'
import NotificationCardHead from './NotificationCardHead'

type Props = {
  item: NotificationApiType
  className?: string
  onMarkAsRead: (id: string) => void
}

const NotificationCard: FC<Props> = ({ item, className, onMarkAsRead }) => {
  const router = useRouter()

  const isNew = !item.isRead

  const handleCardClick = useCallback(() => {
    if (item.deepLink) {
      router.push(`/${item.deepLink}`)
      onMarkAsRead(item.id)
    }
  }, [item, onMarkAsRead, router])

  return (
    <button
      aria-label="Перейти в уведомление"
      type="button"
      className={cn(
        'w-full space-y-16 rounded-12 border border-transparent bg-white p-16 text-left lg:space-y-12 sm:space-y-8 sm:p-12',
        isNew && 'border-beige-70',
        className
      )}
      onClick={handleCardClick}
    >
      <NotificationCardHead item={item} onMarkAsRead={onMarkAsRead} />
      <NotificationCardBody item={item} />
    </button>
  )
}

export default NotificationCard
